module.exports = __webpack_public_path__ + "img/Sandro.5ca890d5.jpg";